module.exports = __webpack_public_path__ + "static/img/25SSD-BW7LVV4F.9ee13ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/25SSD-BW7LVV4F.png
// module id = pBxX
// module chunks = 16